var _image, _text, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "189px",
    height: "50px",
    viewBox: "0 0 189 50",
    enableBackground: "new 0 0 189 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    display: "none",
    overflow: "visible",
    width: 1552,
    height: 416,
    xlinkHref: "powered by logo_JPG.jpg",
    transform: "matrix(0.1383 0 0 0.1383 -22.8326 -78.3793)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -38.0038 -128.9211)",
    fontFamily: "'AspiraWideW01-Bold'",
    fontSize: 16.4877
  }, "P")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#572148",
    d: "M65.337,37.711L55.128,27.537l-1.695,1.696v3.686h-4.345V13.607h4.345v9.479l9.491-9.479l3.073,3.073 l-7.807,7.784l10.221,10.174L65.337,37.711z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#572148",
    d: "M82.164,23.263c0-1.46-0.522-2.708-1.566-3.744c-1.036-1.044-2.285-1.566-3.744-1.566 c-1.476,0-2.732,0.519-3.768,1.555c-1.028,1.028-1.542,2.281-1.542,3.757c0,1.484,0.514,2.739,1.542,3.768 c1.028,1.028,2.285,1.543,3.768,1.543c1.476,0,2.728-0.514,3.757-1.543C81.646,25.994,82.164,24.738,82.164,23.263z M86.509,23.263 c0,2.677-0.942,4.958-2.826,6.842c-1.899,1.876-4.176,2.815-6.829,2.815c-2.685,0-4.965-0.939-6.842-2.815 c-1.876-1.876-2.815-4.157-2.815-6.842c0-2.653,0.939-4.93,2.815-6.829c1.884-1.884,4.164-2.826,6.842-2.826 c2.637,0,4.907,0.95,6.806,2.85C85.559,18.356,86.509,20.624,86.509,23.263z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#572148",
    d: "M100.263,32.918l-8.208-11.375v11.375H87.71V13.607h4.345l8.208,11.363V13.607h4.357v19.311H100.263z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#572148",
    d: "M111.367,17.952v3.133h7.725v4.345h-7.725v7.489h-4.345V13.607h14.484v4.345H111.367z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#572148",
    d: "M135.518,32.918v-7.489h-8.206v7.489h-4.345V13.607h4.345v7.478h8.206v-7.478h4.357v19.311H135.518z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#572148",
    d: "M158.574,24.463c0,2.355-0.82,4.353-2.461,5.994s-3.635,2.461-5.982,2.461c-2.355,0-4.353-0.82-5.994-2.461 s-2.461-3.639-2.461-5.994V13.607h4.345v10.856c0,1.138,0.4,2.108,1.201,2.909c0.801,0.801,1.771,1.201,2.909,1.201 s2.105-0.4,2.897-1.201c0.801-0.801,1.201-1.771,1.201-2.909V13.607h4.345L158.574,24.463L158.574,24.463z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#572148",
    d: "M172.916,27.007c0-0.432-0.157-0.801-0.471-1.107c-0.306-0.314-0.672-0.471-1.095-0.471h-6.617v3.144h6.617 c0.432,0,0.801-0.153,1.107-0.459C172.764,27.807,172.916,27.438,172.916,27.007z M172.433,19.517c0-0.408-0.149-0.773-0.448-1.095 c-0.29-0.314-0.651-0.471-1.084-0.471h-6.169v3.133h6.134c0.432,0,0.801-0.153,1.107-0.459 C172.28,20.319,172.433,19.95,172.433,19.517z M177.297,27.537c0,1.515-0.616,2.802-1.848,3.862 c-1.178,1.013-2.535,1.519-4.075,1.519h-10.986V13.607h10.479c1.515,0,2.869,0.494,4.063,1.484c1.265,1.036,1.896,2.296,1.896,3.78 c0,1.711-0.707,3.077-2.12,4.098C176.434,24.012,177.297,25.535,177.297,27.537z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#572148",
    d: "M14.327,32.794c-4.108-4.108-4.108-10.768,0-14.877L29.535,2.711l2.149,2.149 c-1.095,1.095-1.095,2.872,0,3.967c1.095,1.095,2.872,1.095,3.967,0l2.149,2.149L24.282,24.491l-7.666-5.938l6.801,6.801 l-8.264,8.264L14.327,32.794z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#572148",
    d: "M23.418,41.886l-9.09-9.09c-4.108-4.108-4.108-10.768,0-14.877l0.826-0.826l16.543,16.543 c-0.035,0.016-0.068,0.039-0.097,0.068l-0.408,0.41c-0.137,0.137-0.137,0.359,0,0.495c0.137,0.137,0.359,0.137,0.495,0l0.41-0.41 c0.029-0.029,0.052-0.061,0.068-0.097l5.634,5.634l-2.149,2.149l0,0c-1.095-1.095-2.872-1.095-3.967,0 c-1.095,1.095-1.095,2.872,0,3.967l0,0L29.534,48l-5.62-5.62l0.408-0.408c0.137-0.137,0.137-0.359,0-0.495 c-0.137-0.137-0.359-0.137-0.495,0L23.418,41.886z M24.645,40.658c-0.137,0.137-0.137,0.359,0,0.495 c0.137,0.137,0.359,0.137,0.495,0l0.818-0.818c0.137-0.137,0.137-0.359,0-0.495c-0.137-0.137-0.359-0.137-0.495,0L24.645,40.658z  M26.281,39.022c-0.137,0.137-0.137,0.359,0,0.495c0.137,0.137,0.359,0.137,0.495,0l0.818-0.818c0.137-0.137,0.137-0.359,0-0.495 c-0.137-0.137-0.359-0.137-0.495,0L26.281,39.022z M27.917,37.386c-0.137,0.137-0.137,0.359,0,0.495 c0.137,0.137,0.359,0.137,0.495,0l0.818-0.818c0.137-0.137,0.137-0.359,0-0.495c-0.137-0.137-0.359-0.137-0.495,0L27.917,37.386z  M29.554,35.749c-0.137,0.137-0.137,0.359,0,0.495c0.137,0.137,0.359,0.137,0.495,0l0.818-0.818c0.137-0.137,0.137-0.359,0-0.495 c-0.137-0.137-0.359-0.137-0.495,0L29.554,35.749z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.832,
    y: -18.84,
    fill: "#572148",
    width: 6.98,
    height: 4.315
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBrown);
export default __webpack_public_path__ + "static/media/logo-brown.87af1a17bd10d2c71ff67bfe9e3994c7.svg";
export { ForwardRef as ReactComponent };